import React, { memo } from 'react'
import { Outlet, Navigate } from 'react-router-dom';
import { isAdmin } from './common/authentification-functions';
import { useForceLightTheme } from '../theme/useForceLightTheme';
import { ApplicationRoutes } from '../routes';

type Props = {}

const AdminGuard: React.FC<Props> = memo((props: Props) => {
    // Admin portal is light-only (no theme toggle); pin light regardless of the
    // OS / customer-portal preference.
    useForceLightTheme();

    if(!isAdmin()){
        return <Navigate to={`/${ApplicationRoutes.ADMIN_BASE}`} replace/>
    }

    return (
        <Outlet />
    )
})

export default AdminGuard